import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "view/quick-upload/constants";

const { actions, reducer } = createSlice({
  name: "quickUpload",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
    setQuickUploadFormData(state, actions) {
      const {
        emailAddress,
        username,
        phoneNumber,
        name,
        horoscopeImage,
        idProofImage,
        photo1,
        photo2,
        photo3,
        termsAndCondition,
      } = actions.payload;

      state.name = name;
      state.phoneNumber = phoneNumber;
      state.emailAddress = emailAddress;
      state.horoscopeImage = horoscopeImage;
      state.idProofImage = idProofImage;
      state.photo1 = photo1;
      state.photo2 = photo2;
      state.photo3 = photo3;
      state.termsAndCondition = termsAndCondition;
      state.username = username;
    },
  },
});

export { actions };
export default reducer;
